import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  copy_to_form(event) {
    const message = event.currentTarget.dataset.message
    const messageTextArea = document.querySelector(
      "[data-message-filler-target='input']"
    )

    if (!message || !messageTextArea) {
      console.warn("No element found to copy message")
      return
    }

    messageTextArea.value = message
    messageTextArea.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
